import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { TitleCasePipe } from '@angular/common';

import { SdButtonComponent, SdHtmlComponent, SdThemeComponent, ThemesEnum } from '@seb/web-design-system/core';

import { IInfoBanner } from './info-banner.interface';

@Component({
  selector: 'sd-info-banner',
  templateUrl: './info-banner.component.html',
  styleUrls: ['./info-banner.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    SdButtonComponent,
    SdHtmlComponent,
    TranslateModule,
    TitleCasePipe
  ]
})
export class SdInfoBannerComponent extends SdThemeComponent {
  @Input()
  textKey: string;

  @Input()
  data: IInfoBanner;

  @Input()
  isVisible = true;

  @Output()
  isVisibleChange = new EventEmitter<boolean>();

  buttonTheme: ThemesEnum = ThemesEnum.default;

  close() {
    this.isVisible = false;
    this.isVisibleChange.emit(this.isVisible);
  }
}
